var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from 'mobx';
import TimeUtils from '@business/utils/time';
import { system } from '@config/system';
import { persistentPropertyStorage } from '../PersistentPropertyStorage';
export default class SearchPanel {
    constructor() {
        Object.defineProperty(this, "stagedValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        makeObservable(this);
    }
    get storageKey() {
        return 'searchPanel';
    }
    clear() {
        this.value = {};
    }
    clearStagedValue() {
        this.stagedValue = {};
    }
    initializeComponent(value) {
        this.value = value;
        this.stagedValue = value;
    }
    load() {
        // The hosted experience must always rely on URL params
        if (system.isHostedExperience) {
            return;
        }
        const loadedData = persistentPropertyStorage.getItem(this.storageKey);
        if (!loadedData)
            return;
        const data = JSON.parse(loadedData);
        this.value = Object.assign(Object.assign({}, data.value), { checkin: this.parseDate(data.value.checkin), checkout: this.parseDate(data.value.checkout) });
        this.stagedValue = Object.assign(Object.assign({}, data.stagedValue), { checkin: this.parseDate(data.stagedValue.checkin), checkout: this.parseDate(data.stagedValue.checkout) });
    }
    parseDate(date) {
        return date ? TimeUtils.fromIso(date, { startOfDay: true }) : undefined;
    }
    save() {
        // The hosted experience must always rely on URL params
        if (system.isHostedExperience) {
            return;
        }
        const data = {
            stagedValue: Object.assign(Object.assign({}, this.stagedValue), { checkin: this.stagedValue.checkin
                    ? TimeUtils.toDateString(this.stagedValue.checkin)
                    : undefined, checkout: this.stagedValue.checkout
                    ? TimeUtils.toDateString(this.stagedValue.checkout)
                    : undefined }),
            value: Object.assign(Object.assign({}, this.value), { checkin: this.value.checkin
                    ? TimeUtils.toDateString(this.value.checkin)
                    : undefined, checkout: this.value.checkout
                    ? TimeUtils.toDateString(this.value.checkout)
                    : undefined }),
        };
        persistentPropertyStorage.setItem(this.storageKey, JSON.stringify(data));
    }
    set(value) {
        this.value = Object.assign(Object.assign({}, this.value), value);
        this.stagedValue = Object.assign(Object.assign({}, this.stagedValue), value);
    }
    setStagedValue(value) {
        this.stagedValue = Object.assign(Object.assign({}, this.stagedValue), value);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], SearchPanel.prototype, "stagedValue", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SearchPanel.prototype, "value", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SearchPanel.prototype, "clear", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SearchPanel.prototype, "clearStagedValue", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SearchPanel.prototype, "initializeComponent", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SearchPanel.prototype, "set", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SearchPanel.prototype, "setStagedValue", null);
